/**
 * Owns the parent's mirror of the in-progress workflow document edited
 * by `<PharmaQuestionsWithAllBranching />`.
 *
 * The questions component holds the live state internally; this hook
 * exposes the latest snapshot to the layout (so submission flows can
 * send the user's actual edits as the PUT payload) without forcing the
 * layout to re-derive that state itself.
 *
 * @module pharmaQuestionaire/hooks/useQuestionnaireWorkflowDocument
 */
import { useCallback, useState } from "react";
import { PharmaBranchedQuestionnaire } from "../../../data-model/cmmMedicalNeccessityQuestionnaire";

interface UseQuestionnaireWorkflowDocumentReturn {
  /** Latest in-memory questionnaire as edited by the user, or `null`. */
  workflowDocument: PharmaBranchedQuestionnaire | null;
  /** Stable setter wired into `<PharmaQuestionsWithAllBranching />`. */
  handleWorkflowDocumentChange: (document: PharmaBranchedQuestionnaire) => void;
}

export const useQuestionnaireWorkflowDocument =
  (): UseQuestionnaireWorkflowDocumentReturn => {
    const [workflowDocument, setWorkflowDocument] =
      useState<PharmaBranchedQuestionnaire | null>(null);

    const handleWorkflowDocumentChange = useCallback(
      (document: PharmaBranchedQuestionnaire) => setWorkflowDocument(document),
      [],
    );

    return { workflowDocument, handleWorkflowDocumentChange };
  };
